import { getCookie, setCookie } from './utils';
import { onReady } from './utils.js';

onReady( function() {
	const city_select = document.querySelector( '.js-weather-widget-select' );
	if ( ! city_select ) {
		return;
	}

	const selected = getCookie( 'weather_city' );
	if ( selected ) {
		city_select.value = selected;
	} else {
		city_select.value = 'weather-100727018'; // Sofia as default.
	}

	city_select.addEventListener( 'click', function() {
		const parent = this.closest( '.c-weather-widget' );
		const selected = this.value;

		// Hide current active location.
		parent.querySelectorAll( '.c-weather-widget__location_active' ).forEach( function( li ) {
			li.classList.remove( 'c-weather-widget__location_active' );
		} );

		// Show new active location.
		parent.querySelector( '.c-weather-widget__location[data-location="' + selected + '"]' ).classList.add( 'c-weather-widget__location_active' );

		setCookie( 'weather_city', selected, 30 );
	} );
} );
